import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, KeepAlive as _KeepAlive, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-17c7f692"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "manage-page"
};
const _hoisted_2 = {
  class: "menu-logo"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://wyc-fe-static.yun-sk.com/static/wyt/web-logo.png",
  class: "logo-1"
}, null, -1));

const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "header-container"
};
const _hoisted_6 = {
  class: "header"
};
const _hoisted_7 = {
  class: "select-text text"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 修改密码 ");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("退出登录");

const _hoisted_10 = {
  key: 1,
  class: "home-nav"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav-header"
}, "快捷入口", -1));

const _hoisted_12 = {
  class: "list"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "name"
};
import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useDebounce } from '@/utils';
import { useRoute, useRouter } from 'vue-router';
import MenuTree from './component/MenuTree.vue';
export default {
  name: 'ManagePage',

  setup(__props) {
    const store = useStore();
    onMounted(() => {
      window.addEventListener('resize', useDebounce(() => {
        if (document.body.clientWidth < 1280) {
          store.commit('setIsOpenMenuTree', false);
        }
      }));
      store.dispatch('router/getRouteList');

      if (store.state.user.userType === 1) {
        router.replace({
          name: 'AnalysisApp'
        });
      }
    });
    const route = useRoute();
    const router = useRouter();
    const actTab = ref(route.name); // 侧边导航隐藏/展开

    const isOpenMenuTree = computed(() => store.state.isOpenMenuTree);

    function changeIsOpenMenuTree() {
      store.commit('setIsOpenMenuTree', !isOpenMenuTree.value);
    } // 切换导航 更新选中tab


    watch(() => route.name, newVal => {
      actTab.value = newVal;
    }); // 侧边栏 数据展示
    // const menuTreeData = store.state.router.menuTreeList;

    const menuTreeData = computed(() => store.state.router.menuTreeList); // tab选项卡

    const tabsList = computed(() => store.state.router.tabsList); // 选项卡改变 切换路由

    function tabChange(row) {
      let to = tabsList.value.find(i => i.name === row.props.name);
      let keepAlive = to.name === 'BusinessManage'; // BusinessManage 缓存

      router.push(to, keepAlive);
    }

    function removeTab(tabName) {
      store.commit('router/updateTabsList', {
        tab: tabsList.value.find(i => i.name === tabName) || null,
        type: 'delete'
      });
      const lastTab = tabsList.value[tabsList.value.length - 1];

      if (lastTab) {
        router.push(lastTab);
      } else {
        router.push({
          name: 'ManagePage'
        });
      }
    }

    function handleCommand(command) {
      console.log(command);
      const methods = {
        changePwd: () => {
          router.push({
            name: 'AccountSafe'
          });
        },
        logout: () => {
          store.dispatch('user/logout');
          router.replace({
            name: 'Login'
          });
        }
      };
      methods[command] && methods[command]();
    } // 页面缓存数据


    const keepAliveList = computed(() => store.state.router.keepAliveList); // home-nav

    const homeNav = computed(() => {
      let userType = store.state.user.userType;

      if (userType == 3) {
        return [{
          name: '添加业务员',
          route: 'SalesmanAccountManage',
          icon: 'home_nav_1.png'
        }, {
          name: '团队配置',
          route: 'ControlSalesTeam',
          icon: 'home_nav_2.png'
        }, {
          name: '查看订单',
          route: 'TeamOrder',
          icon: 'home_nav_3.png'
        }, {
          name: '制定目标',
          route: 'goal',
          icon: 'home_nav_4.svg'
        }, {
          name: '制定任务',
          route: 'assignment',
          icon: 'home_nav_5.svg'
        }, {
          name: '业务员授信',
          route: 'creditSalesman',
          icon: 'home_nav_6.png'
        }, {
          name: '逾期客户查看',
          route: 'creditCust',
          query: {
            expireCustCount: 1
          },
          icon: 'home_nav_7.png'
        }];
      } else {
        return [{
          name: '添加业务员',
          route: 'SalesmanAccountManage',
          icon: 'home_nav_1.png'
        }, {
          name: '团队配置',
          route: 'ControlSalesTeam',
          icon: 'home_nav_2.png'
        }, {
          name: '查看订单',
          route: 'TeamOrder',
          icon: 'home_nav_3.png'
        }];
      }
    });

    function toPage(item) {
      router.push({
        name: item.route,
        query: item.query
      });
    }

    const menuLogoText = computed(() => {
      let userType = store.state.user.userType;

      if (userType == 3) {
        return 'https://wyc-fe-static.yun-sk.com/static/wyt/万药通-团队管理端.png';
      } else {
        return 'https://wyc-fe-static.yun-sk.com/static/wyt/万药通-平台管理端.png';
      }
    });
    return (_ctx, _cache) => {
      const _component_el_menu = _resolveComponent("el-menu");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_UserFilled = _resolveComponent("UserFilled");

      const _component_arrow_down = _resolveComponent("arrow-down");

      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      const _component_el_dropdown = _resolveComponent("el-dropdown");

      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_tabs = _resolveComponent("el-tabs");

      const _component_router_view = _resolveComponent("router-view");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_scrollbar, {
        class: "menu-tree"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _unref(isOpenMenuTree) ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _unref(menuLogoText)
        }, null, 8, _hoisted_4)) : _createCommentVNode("", true)]), _createVNode(_component_el_menu, {
          collapse: !_unref(isOpenMenuTree),
          class: _normalizeClass(["menu", _unref(isOpenMenuTree) ? '' : 'close']),
          "collapse-transition": false,
          "default-active": _unref(route).name
        }, {
          default: _withCtx(() => [_createVNode(MenuTree, {
            treeList: _unref(menuTreeData)
          }, null, 8, ["treeList"])]),
          _: 1
        }, 8, ["collapse", "default-active", "class"])]),
        _: 1
      }), _createElementVNode("div", {
        class: _normalizeClass(["layout-right", _unref(isOpenMenuTree) ? '' : 'max-size'])
      }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_icon, {
        size: 20,
        class: "icon text",
        onClick: changeIsOpenMenuTree
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(isOpenMenuTree) ? 'Fold' : 'Expand')))]),
        _: 1
      }), _createVNode(_component_el_dropdown, {
        onCommand: handleCommand
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            command: "changePwd"
          }, {
            default: _withCtx(() => [_hoisted_8]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "logout"
          }, {
            default: _withCtx(() => [_hoisted_9]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_7, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_UserFilled)]),
          _: 1
        }), _createTextVNode("   " + _toDisplayString(_ctx.$store.state.user.username) + " ", 1), _createVNode(_component_el_icon, {
          class: "el-icon--right"
        }, {
          default: _withCtx(() => [_createVNode(_component_arrow_down)]),
          _: 1
        })])]),
        _: 1
      })])]), _createVNode(_component_el_scrollbar, {
        class: "view-container"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tabs, {
          modelValue: actTab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => actTab.value = $event),
          type: "card",
          class: "tabs",
          closable: "",
          onTabClick: tabChange,
          onTabRemove: removeTab
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabsList), tab => {
            return _openBlock(), _createBlock(_component_el_tab_pane, {
              key: tab.name,
              label: tab.label,
              name: tab.name,
              closable: ""
            }, null, 8, ["label", "name"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"]), _unref(tabsList).length ? (_openBlock(), _createBlock(_component_router_view, {
          key: 0,
          class: "view"
        }, {
          default: _withCtx(({
            Component
          }) => [(_openBlock(), _createBlock(_KeepAlive, {
            include: _unref(keepAliveList)
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1032, ["include"]))]),
          _: 1
        })) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homeNav), item => {
          return _openBlock(), _createElementBlock("div", {
            class: "item",
            key: item.route,
            onClick: $event => toPage(item)
          }, [_createElementVNode("img", {
            src: 'https://wyc-fe-static.yun-sk.com/static/wyt/' + item.icon
          }, null, 8, _hoisted_14), _createElementVNode("span", _hoisted_15, _toDisplayString(item.name), 1)], 8, _hoisted_13);
        }), 128))])]))]),
        _: 1
      })], 2)]);
    };
  }

};